import { FC } from 'react';
import { DragIndicator } from '@mui/icons-material';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { theme } from '../../../styles/theme';
// Models
import { IDropdownResponse, IExternalUser } from '../../../models';
// Components
import { ICalendarClosingLocation } from '../../../models/calendar';

type IEvent = {
  address: string;
  buildId: number;
  clientAttendees: IDropdownResponse[];
  closingLocation: ICalendarClosingLocation;
  description: string;
  end: Date;
  endDateTime: Date;
  eventType: string;
  externalUsers: IExternalUser[];
  interanlUsers: any[];
  isAllDay: boolean;
  location: string;
  lot: number;
  neighborhoodName: string;
  phase: string;
  sageId: number;
  start: Date;
  startDateTime: Date;
  title: string;
  eventTitle: string;
};

interface IReactBigCalendarEvent {
  event: IEvent;
  title: string;
  isMonthView: boolean;
}

type ICustomEvent = {
  event: IReactBigCalendarEvent;
  action: (event: IEvent) => void;
  isMonthView: boolean;
};

export const CustomEvent: FC<ICustomEvent> = ({ event, action, isMonthView }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles({ isMonthView, isMobile });

  return (
    <Grid
      sx={isMonthView ? { height: '100%' } : null}
      container
      onClick={() => action?.(event?.event)}
      alignItems="center"
      position="relative"
    >
      {isMonthView && (
        <>
          <Grid item xs={11} className={classes.eventTextContainer}>
            <Typography className={classes.eventText} variant="body2">
              {`${event?.event?.eventTitle}`}
            </Typography>
          </Grid>
          <Grid item xs={1} className={classes.dragIndicator}>
            <DragIndicator fontSize="small" />
          </Grid>
        </>
      )}
      {!isMonthView && (
        <>
          <Grid item xs={11}>
            <Typography className={classes.eventTextTitle}>
              {`${event?.event?.eventTitle}`}
            </Typography>
          </Grid>
          <Grid item xs={1} className={classes.dragIndicator}>
            <DragIndicator fontSize="small" />
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.eventTextType}>
              {`${event?.event?.eventType}`}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};

const useStyles = makeStyles<Theme, { isMonthView: boolean; isMobile: boolean }>(
  (theme: Theme) => ({
    eventTextContainer: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    eventText: {
      whiteSpace: 'nowrap',
      wordBreak: 'break-word',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    eventTextTitle: {
      [theme.breakpoints.down('sm')]: {
        marginTop: '0.15rem',
        fontSize: '0.75rem',
      }
    },
    eventTextType: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.75rem',
      }
    },
    dragIndicator: ({ isMonthView }) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      height: '100%',
      ...(!isMonthView && {
        height: 'auto',
        position: 'absolute',
        top: '.15rem',
        right: '-0.25rem',
      }),
    }),
  })
);
